import React from 'react';
import {Spinner, Stack} from '@shopify/polaris';
import {Redirect} from 'react-router-dom';
import {Routes} from '../../utilities';
import withAuth, {AuthState} from '../../sections/with-auth/withAuth';
import {AppLayout} from '../app-layout';

interface OwnProps {
  children: React.ReactNode;
}

type CombinedProps = OwnProps & AuthState;

const Loading = (
  <AppLayout>
    <AppLayout.Container>
      <AppLayout.Section fill>
        <Stack
          alignment="center"
          distribution="center"
          vertical
          spacing="extraLoose"
        >
          <Stack.Item />
          <Spinner />
          <Stack.Item />
        </Stack>
      </AppLayout.Section>
    </AppLayout.Container>
  </AppLayout>
);

function RequireAuth({
  loaded,
  currentShop,
  currentShopUser,
  children,
}: CombinedProps) {
  if (!loaded) return Loading;

  return currentShop && currentShopUser ? (
    <>{children}</>
  ) : (
    <Redirect to={Routes.homePath()} />
  );
}

export default withAuth(RequireAuth);
